import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient so non-React code (thunks, bootstrap) can prefetch/invalidate
 * the same cache React hooks use.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});
